module.exports = __webpack_public_path__ + "static/media/ic_dustbin_selected.60999a6a.svg";